import { render, staticRenderFns } from "./delivery-issues.vue?vue&type=template&id=f38a7462&"
import script from "./delivery-issues.vue?vue&type=script&lang=js&"
export * from "./delivery-issues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports